import React from "react";
import { useTranslation } from "utilities/i18n";
import { useLogout } from "./Auth0ProviderWithHistory";

export const TokenExpired: React.FC = () => {
  const { t } = useTranslation();
  const logout = useLogout();
  return (
    <span>
      <p>{t("AUTH_EXPIRED")}</p>
      <p>
        <button className={"btn"} onClick={() => logout()}>
          {t("AUTH_ERROR_ACTION")}
        </button>
      </p>
    </span>
  );
};
